export type DirectoryEmployee = {
  id: string;
  name: string;
  department: string;
  employeeNumber: string;
  role: string;
  matchIds: string[];
};

export type ProjectCatalogItem = {
  code: string;
  id: string;
  name: string;
};

export type TeamMemberRef = {
  id: string;
  name: string;
  role: string;
};

export const toDirectoryEmployee = (emp: any): DirectoryEmployee => {
  const businessId = String(emp?.employeeId ?? '').trim();
  const guid = String(emp?.id ?? '').trim();
  const employeeNumber = String(emp?.employeeNumber ?? '').trim();
  const matchIds = Array.from(new Set([businessId, guid, employeeNumber].filter(Boolean)));
  return {
    id: businessId || guid,
    name: emp?.name || '-',
    department:
      emp?.departmentName || emp?.department?.name || emp?.track || emp?.designation || '-',
    employeeNumber: employeeNumber || businessId,
    role: String(emp?.designation || emp?.role || emp?.billingRole || ''),
    matchIds
  };
};

export const toCatalogProject = (project: any): ProjectCatalogItem | null => {
  const code = String(project?.key || project?.code || project?.projectCode || project?.id || '').trim();
  const id = String(project?.id || project?.key || project?.code || project?.projectCode || '').trim();
  const name = String(project?.name || project?.projectName || '').trim();
  if (!code || !name) {
    return null;
  }
  return { code, id, name };
};

const sameId = (left: string, right: string) =>
  Boolean(left) && left.toLowerCase() === right.toLowerCase();

export const teamMembersFromRoles = (roles: any[]): TeamMemberRef[] => {
  const seen = new Set<string>();
  const members: TeamMemberRef[] = [];
  (roles || []).forEach((role) => {
    const roleName = String(role?.role || '').trim();
    (role?.resourceAllocations || []).forEach((resource) => {
      const id = String(resource?.employeeId ?? '').trim();
      if (!id || seen.has(id)) {
        return;
      }
      seen.add(id);
      members.push({
        id,
        name: String(resource?.name || '').trim(),
        role: roleName
      });
    });
  });
  return members;
};

export const findDirectoryEmployee = (employees: DirectoryEmployee[], allocationId: string) =>
  employees.find(
    (employee) =>
      sameId(employee.id, allocationId) ||
      (employee.matchIds || []).some((matchId) => sameId(matchId, allocationId))
  );

export const employeesForTeam = (
  members: TeamMemberRef[],
  directory: DirectoryEmployee[]
): DirectoryEmployee[] =>
  members.map((member) => {
    const known = findDirectoryEmployee(directory, member.id);
    if (known) {
      return known;
    }
    return {
      id: member.id,
      name: member.name || member.id,
      department: '-',
      employeeNumber: member.id,
      role: member.role,
      matchIds: [member.id]
    };
  });
